module.exports = __webpack_public_path__ + "static/media/radio-circle-selected.74d5f40c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/theme/Allianz/images/radio-circle-selected.svg
// module id = 803
// module chunks = 0